import {RemoteGetExamsProviderLocationAccredited} from 'data/usecases/private/booking-flow/exams/remote-get-exams-provider-location-accredited';
import {GetExamsProviderLocationAccredited} from 'domain/usecases/private/booking-flow/exams/get-exams-provider-location-accredited';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamsProviderLocationAccredited = (): GetExamsProviderLocationAccredited =>
	new RemoteGetExamsProviderLocationAccredited(
		makeBFFApiUrl(BookingFlowEndPoints.examProvidersLocationAccredited),
		makeAuthorizeHttpClientDecorator(),
	);
